import { Http } from '../helpers'

export const PersonnelService = {
  search(params) {
    return Http.get('/personnel', { params: params })
  },
  view(id) {
    return Http.get('/personnel/' + id)
  },
}
